var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconWrite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1494_202180",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    y: 0.179199,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1494_202180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99996 14.9792C3.63329 14.9792 3.3194 14.8487 3.05829 14.5876C2.79718 14.3265 2.66663 14.0126 2.66663 13.6459V4.31256C2.66663 3.9459 2.79718 3.63201 3.05829 3.3709C3.3194 3.10979 3.63329 2.97923 3.99996 2.97923H9.94996L8.61663 4.31256H3.99996V13.6459H13.3333V9.01256L14.6666 7.67923V13.6459C14.6666 14.0126 14.5361 14.3265 14.275 14.5876C14.0138 14.8487 13.7 14.9792 13.3333 14.9792H3.99996ZM11.45 3.36257L12.4 4.2959L7.99996 8.6959V9.6459H8.93329L13.35 5.22923L14.3 6.16256L9.49996 10.9792H6.66663V8.1459L11.45 3.36257ZM14.3 6.16256L11.45 3.36257L13.1166 1.6959C13.3833 1.42923 13.7027 1.2959 14.075 1.2959C14.4472 1.2959 14.7611 1.42923 15.0166 1.6959L15.95 2.6459C16.2055 2.90145 16.3333 3.21256 16.3333 3.57923C16.3333 3.9459 16.2055 4.25701 15.95 4.51257L14.3 6.16256Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconWrite);
export default __webpack_public_path__ + "static/media/profile-icon-write.9c7f1e0134fc551885ebde56ab392c14.svg";
export { ForwardRef as ReactComponent };